import Modal, { ModalProps } from './Modal';

export type { ModalProps };
export default Modal;
